import { ReportColumnType } from '../../types/report/ReportColumnType';

export const transactionsReportColumns = {
    Name: ReportColumnType.CustomerFullName,
    Partner: ReportColumnType.PartnerName,
    Reference: ReportColumnType.OrderNumber,
    'Invoice Number': ReportColumnType.InvoiceNumber,
    'Transaction Type': ReportColumnType.TransactionType,
    Amount: ReportColumnType.Amount,
    Date: ReportColumnType.CreatedOn,
    'Transaction Date': ReportColumnType.TransactionDate,
    'Product Code': ReportColumnType.ProductCode,
    'Is Manual': ReportColumnType.IsManual,
};
